export default "__VITE_ASSET__aac4de7e__"